import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;
